import React from "react";
import { Link } from "react-router-dom";
import ResetIcon from "components/icons/ResetIcon"
import AccountBanner from "components/AccountBanner";
import PenIcon from "components/icons/PenIcon";
import ActionButton from "components/ActionButton";
import Modal from 'react-modal';

import { getRequest, postRequest } from "sharedUtils/httpUtils";
import { convertToNumericMonthAndDayAndYearAndTime } from "sharedUtils/timeUtils";

import { DateTime } from "luxon";
import { createReturn } from "typescript";

class SocialPlatforms extends React.Component {

    state = {
        socialPlatforms: [],
    }

    async componentDidMount() {
        let socialPlatforms = await this.fetchSocialPlatforms()

        this.setState({ socialPlatforms });
    }

    breadCrumbList = [
        { link: '/Admin', text: 'Admin' },
        { link: '/Admin/SocialPlatforms', text: 'Social Platforms' }
    ]

    displayHeaders = () => {
        let headers = ["Name", "Live"];
        return headers.map((header, i) => {
            if (i === 2 || i === 3) {
                return (
                    <th key={i} style={{ width: "110px" }}>
                        <strong>{header}</strong>
                    </th>
                )
            }
            return (
                <th key={i}>
                    <strong>{header}</strong>
                </th>
            )

        })
    }


    displayRows = () => {
        return this.state.socialPlatforms?.map((social, i) => {    

            return (
                <tr key={i}>
                    <td>
                        {social?.name}
                    </td>

                    <td style={{ width: "200px", cursor: "pointer" }}>
                        <div className={`commission-status-${social?.live ? "green" : "red"}`}>
                            <div onClick={() => this.updateSocialPlatformLive(social?.platformTypeId, social?.live) } >
                                <ResetIcon height="12" width="12" pathStroke="#b3b3b3" style={{ position: "relative", left: "20%", transform: "translate(-50%, 1px)" }} />
                            </div>
                        </div>
                    </td>
                </tr>
            )
        })
    }

    fetchSocialPlatforms = async () => {
        let url = "api/Merchant/GetPlatformConfigs";
        let configs = await getRequest(url);
        return configs;
    }

    updateSocialPlatformLive = async (platformTypeId, live) => {
        let url = "api/Merchant/UpdatePlatformConfigs";
        let config = {
            platformTypeId,
            live: !live
        };

        await postRequest(url, config);

        this.setState(prevState => ({
            socialPlatforms: prevState.socialPlatforms.map(social =>
                social.platformTypeId === platformTypeId
                    ? { ...social, live: !social.live }
                    : social
            )
        }));
    };


    render() {
        return (
            <>              
                <section>
                    <AccountBanner breadCrumbList={this.breadCrumbList}>
                        <h1 className="mb-4">Social Platforms</h1>
                        <p></p>
                    </AccountBanner>
                </section>

                <section className="gray-bg full-height">
                    <div className="container pt-0">

                        <div className="row mx-0 my-0">
                            <div className="table-responsive product-table mt-3">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            {this.displayHeaders()}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {this.displayRows()}
                                    </tbody>
                                </table>


                            </div>
                        </div>

                    </div>
                </section>
            </>
        )
    }
}



export default SocialPlatforms